// extracted by mini-css-extract-plugin
export default {"title-table-line":"_title-table-line_I7sRN2","group-title":"_group-title_C7vZht"};